import request from '@/utils/request'
import shop from './shop'
import food from "@/api/food";
import order from "@/api/order";


// 公共分类（字典数据）
export const commonConfig = function (data) {
    return request({
        url: '/api/common/config',
        method: 'get',
        params: data
    })
}

// 单页
export const getAbout = function (data) {
    return request({
        url: '/api/common/about',
        method: 'get',
        params: data
    })
}

// 上传文件
export const upload = function (data) {
    return request({
        url: '/api/common/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: data
    })
}

// 获取全部城市
export const commonArea = function (data) {
    return request({
        url: '/api/common/area',
        method: 'get',
        params: data
    })
}

// 第三方登录
export const getThird = function (data) {
    return request({
        url: '/api/user/third',
        method: 'get',
        params: data
    })
}

//@yuhj250619增加普通登录
export const getLogin = function (data) {
    return request({
        url: '/api/user/login',
        method: 'post',
        data: data
    })
}

// 短信验证码
export const sendSms = function (data) {
    return request({
        url: '/api/sms/send',
        method: 'get',
        params: data
    })
}


export default {
    commonConfig,
    getAbout,
    upload,
    commonArea,

    getThird,
    sendSms,
    getLogin,

    ...shop,
    ...food,
    ...order,
}
